import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { DocumentUpload } from 'components/Documents/DocumentUpload';
import { createMedia, updateMedia } from 'services';
import { showError } from 'utils';
import FilePreviewer from 'react-file-previewer-v2';

interface Media {
  _url?: string;
  [key: string]: any;
}

interface Props {
  showModal: boolean;
  toggleModal: () => void;
  itemSelected: Media | null | { name: string; media: Media; objectId: string; id: string } | undefined;
  onSuccess: () => void;
}

function CreateMediaModal(props: Props): JSX.Element {
  const { showModal, toggleModal, itemSelected, onSuccess } = props;

  const [loading, setLoading] = useState(false);
  const [mediaName, setMediaName] = useState(itemSelected?.name || '');
  const [mediaFile, setMediaFile] = useState<Media | null>(null);
  const [url, setURL] = useState(itemSelected?.media?._url || '');
  const [id, setID] = useState(itemSelected?.objectId || '');

  const handleSubmit = async () => {
    setLoading(true);
    try {
      if (id) {
        const updateData = { name: mediaName, id };
        if (mediaFile) {
          updateData['media'] = mediaFile;
        }
        await updateMedia(updateData);
      } else {
        await createMedia({ name: mediaName, media: mediaFile });
      }
      onSuccess && onSuccess();
      reset();
    } catch (error) {
      showError(error || 'Error creating media');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setMediaName(itemSelected?.name || '');
    setURL(itemSelected?.media?._url || '');
    setID(itemSelected?.objectId || '');
  }, [itemSelected, showModal]);

  const reset = () => {
    setMediaName('');
    setMediaFile(null);
    setURL('');
    toggleModal();
  };

  return showModal ? (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>{(id ? 'Update' : 'Create') + ' Media Item'}</div>
          </div>
          <i className={'fa fa-times'} onClick={reset} />
        </div>
        <div className={styles['modal-body']}>
          <div className='row'>
            <div className='col-12'>
              <div className='form-group'>
                <label>Media Name</label>
                <input
                  type='text'
                  className='form-control'
                  value={mediaName}
                  onChange={(e) => setMediaName(e.target.value)} />
              </div>
            </div>
            <div className='col-12'>
              <div className='form-group'>
                <label>Media</label>
                {!url && <DocumentUpload onDocumentChange={(media: Media) => {
                  setURL(media?._url);
                  setMediaFile(media);
                }} />}
                <div className="uploaded-image-on-modal">
                  {url && <FilePreviewer file={{ url: url }} />}
                </div>
              </div>
              {url && <button
                onClick={() => { setURL(''); setMediaFile(null) }}
                className={'btn btn-danger d-flex ml-auto mr-1'}
                disabled={loading}
              >
                Change Media
              </button>}
            </div>
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={reset}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className={styles['submit-button']}
            disabled={loading || (!mediaName || !mediaFile)}
          >
            {(id ? 'Update' : 'Create') + ' Media Item'}
          </button>
        </div>
      </div>
    </div>
  ) : <></>;
}

export default CreateMediaModal;